module.exports = __webpack_public_path__ + "img/sJokerKing_193x205.b2560eb6.png";